import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from 'react-autocomplete';
import searchSvg from '~/static/images/icons/search.svg';
import * as ST from './search-styled';


const NothingFound = () => (
    <ST.NothingFoundWrapper>
        <ST.NothingFoundTitle>Ничего не нашлось&nbsp;</ST.NothingFoundTitle>
        Возможно, вы неправильно ввели название канала
    </ST.NothingFoundWrapper>
);

export default class ChannelSearch extends React.Component {
    static propTypes = {
        placeholder: PropTypes.string,
        onSearch: PropTypes.func,
        onClearSearch: PropTypes.func,
        items: PropTypes.array,
    };

    static defaultProps = {
        onSearch: () => { },
        onClearSearch: () => { },
        items: [],
        itemValue: 'label',
    };

    state = {
        search: '',
    };

    clearInput = () => {
        this.setSearch('');
    };

    inputHandler = (e) => {
        this.setSearch(e.target.value);
    };

    onSelect = (value, item) => {
        this.setSearch(value, item, () => {
            this.search();
        });
    };

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.search();
        }
    };

    setSearch = (value, item = {}, callback) => {
        this.setState({
            search: value,
            selectedItem: item
        }, callback);
    };

    search = () => {
        const { search, selectedItem } = this.state;
        const { onClearSearch, onSearch } = this.props;

        if (!search) {
            onClearSearch();
        }

        onSearch(selectedItem);
    };

    getItemValue = (item) => {
        return item.title;
    };

    shouldItemRender = (item, value) => {
        if (!value) {
            return false;
        }
        return item.title.toString().toLowerCase().includes(value.toLowerCase());
    };

    renderInput = (props) => {
        const { placeholder } = this.props;
        return (
            <>
                <ST.Input
                    data-test='search-field'
                    {...props}
                    onKeyPress={this.onKeyPress}
                    type='text'
                    placeholder={placeholder}
                    autoFocus={false}
                />
                <ST.SearchButton onClick={this.search} src={searchSvg} alt='Поиск' />
            </>
        );
    };

    renderItem = (item, isHighlighted) => {
        return (
            <ST.SearchItem key={item.id} active={isHighlighted}>
                <ST.ChannelLogo src={item.logo} />
                {item.title}
            </ST.SearchItem>
        );
    };

    renderMenu = (items) => {
        const { search } = this.state;
        return (
            <ST.Dropdown>
                {items.length === 0 && search ? <NothingFound /> : items}
            </ST.Dropdown>
        );
    }

    render() {
        const { items, className } = this.props;
        const { search } = this.state;

        return (
            <ST.SeacrhInput className={className}>
                <Autocomplete
                    wrapperStyle={ST.WRAPPER_STYLE}
                    items={items}
                    value={search}
                    onChange={this.inputHandler}
                    onSelect={this.onSelect}
                    getItemValue={this.getItemValue}
                    shouldItemRender={this.shouldItemRender}
                    renderInput={this.renderInput}
                    renderItem={this.renderItem}
                    renderMenu={this.renderMenu}
                />
            </ST.SeacrhInput>
        );
    }
}
